import type { Infer } from 'superstruct';
import { boolean, object, optional } from 'superstruct';

import { EditPermissionsDto } from '@adflow/shared/util-data';
import { userString } from '@adflow/shared/util-superstruct';

export const AddRoleDto = object({
	name: userString('validations:Required'),
	superuser: optional(boolean()),
	permissions: optional(EditPermissionsDto),
	archived: optional(boolean()),
});

export type AddRoleDto = Infer<typeof AddRoleDto>;
